<template>
  <div>
    <div class="uk-cover-container uk-height-large">
      <img :src="image" :alt="title" uk-cover>
      <div class="uk-overlay uk-overlay-primary uk-position-cover">
        <div class="uk-position-bottom-center uk-width-4-5 uk-width-2-3@m">
          <div class="
          uk-container
          page-header-texts
          uk-margin-xlarge-bottom
        "
          :class="{
            'uk-width-1-1': ! $slots.default,
            'uk-width-4-5': $slots.default,
            'uk-width-2-3@m': $slots.default
          }">
            <h2 class="uk-heading-xsmall uk-text-uppercase uk-margin-auto">
              {{title}}
            </h2>
            <p class="uk-text-center uk-padding-small">&nbsp;
              <slot />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import defaultImage from '@/assets/images/main-header.png';

export default {
  name: 'PageHeader.vue',
  components: {
  },

  props: {
    image: {
      type: String,
      default: defaultImage,
    },
    title: {
      required: true,
      type: String,
    },
  },
};
</script>
